export class DateLocalization {
    static getRuMonth(index: number){
        return [
            "января","февравля","марта","апреля","мая","июня","июля","августа",
            "сентября","октября","ноября","декабря"
        ][index];
    }

    static localizeRu(date: Date){
        return `${date.getDay()} ${DateLocalization.getRuMonth(date.getUTCMonth())} ${date.getFullYear()}г`
    }

}